<template>
  <b-row class="m-3">
    <b-col md="12" v-if="!loading">
      <fieldset class="form-group bg-default" v-if="['ADD'].includes(action)">
        <form @submit.prevent="onSaveSpalProcess">
          <b-form-row>
            <b-col>
              <b-form-group label="SPAL Title *" label-for="title">
                <b-form-input
                  type="text"
                  id="title"
                  v-model="form.title"
                  placeholder="Type Text"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label="Upload SPAL Document *"
                label-for="attachment"
              >
                <b-form-file
                  accept="application/*"
                  multiple
                  name="attachment"
                  id="attachment"
                  v-model="form.attachment"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group label="Notes" label-for="notes">
                <b-form-textarea
                  v-model="form.notes"
                  id="description"
                  rows="3"
                  placeholder="Type Text ..."
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>
              <b-form-group
                label="Is Fix SPAL / CONTRACT ?"
                label-for="is_fix_spal"
              >
                <b-form-checkbox
                  name="check-button"
                  switch
                  inline
                  v-model="form.is_fix_spal"
                >
                  Yes / No
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-form-row>
          <div class="w-100 d-flex mt-4">
            <b-button class="mr-2 w-50" variant="outline-primary" @click="closeSlideSpalProcess">
              Cancel
            </b-button>
            <b-button
              class="w-50"
              type="submit"
              variant="primary"
              :disabled="saving"
            >
              <span v-if="saving" class="spinner-border spinner-border-sm" />
              Submit
            </b-button>
          </div>
        </form>
      </fieldset>
      <div class="overflow-auto">
        <table class="table table-bordered">
          <thead class="thead-light">
            <tr>
              <th class="text-truncate text-center align-middle">SPAL Title</th>
              <th class="text-truncate text-center align-middle">Attachment</th>
              <th class="text-truncate text-center align-middle">
                Fix SPAL / Contract
              </th>
              <th class="text-truncate text-center align-middle">
                Description
              </th>
              <th class="text-truncate text-center align-middle">Status</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(row, idx) in listHistorySpal">
              <tr :key="`spal-row-` + row.id">
                <td class="align-middle">
                  {{ row.title || row.project_contract?.title || '-' }}
                </td>
                <td class="text-center align-middle">
                  <b-button
                    v-if="row?.attachment?.length"
                    variant="secondary"
                    @click="handleOpenFilePreview(`${apiUrl}/download/${row?.attachment?.[0]?.file_url?.replace('upload/', '')}`, 'history-spal-attachment')"
                  >
                    <i class="fa fa-download" aria-hidden="true"></i>
                    Download
                  </b-button>
                  <span v-else>-</span>
                </td>
                <td class="text-center align-middle">
                  <b-badge :variant="row.is_fix_spal ? 'success' : 'secondary'">
                    {{ row.is_fix_spal ? 'Yes' : 'No' }}
                  </b-badge>
                </td>
                <td class="text-center align-middle">
                  <b-button variant="primary" @click="openDescription(row)">
                    Description
                  </b-button>
                </td>
                <td class="text-center align-middle">
                  <div
                    class="text-center cursor-pointer"
                    @click="toggleOpen(idx)"
                  >
                    <svg
                      width="18"
                      height="16"
                      viewBox="0 0 18 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4 10.5H14C14.1427 10.5 14.2617 10.4523 14.357 10.357C14.4523 10.2617 14.5 10.1427 14.5 10C14.5 9.85734 14.4523 9.73833 14.357 9.643C14.2617 9.54767 14.1427 9.5 14 9.5H4C3.858 9.5 3.739 9.54767 3.643 9.643C3.547 9.73833 3.49933 9.85734 3.5 10C3.50067 10.1427 3.54833 10.2617 3.643 10.357C3.73767 10.4523 3.85667 10.5 4 10.5ZM4 7.5H14C14.1427 7.5 14.2617 7.45234 14.357 7.357C14.4523 7.26167 14.5 7.14267 14.5 7C14.5 6.85734 14.4523 6.73834 14.357 6.643C14.2617 6.54767 14.1427 6.5 14 6.5H4C3.858 6.5 3.739 6.54767 3.643 6.643C3.547 6.73834 3.49933 6.85734 3.5 7C3.50067 7.14267 3.54833 7.26167 3.643 7.357C3.73767 7.45234 3.85667 7.5 4 7.5ZM4 4.5H14C14.1427 4.5 14.2617 4.45234 14.357 4.357C14.4523 4.26167 14.5 4.14267 14.5 4C14.5 3.85734 14.4523 3.73834 14.357 3.643C14.2617 3.54767 14.1427 3.5 14 3.5H4C3.858 3.5 3.739 3.54767 3.643 3.643C3.547 3.73834 3.49933 3.85734 3.5 4C3.50067 4.14267 3.54833 4.26167 3.643 4.357C3.73767 4.45234 3.85667 4.5 4 4.5ZM1.616 14C1.15533 14 0.771 13.846 0.463 13.538C0.155 13.23 0.000666667 12.8457 0 12.385V1.615C0 1.155 0.154333 0.770669 0.463 0.462002C0.771667 0.153335 1.15567 -0.000664511 1.615 2.15517e-06H16.385C16.845 2.15517e-06 17.229 0.154002 17.537 0.462002C17.845 0.770002 17.9993 1.15434 18 1.615V15.133C18 15.493 17.8343 15.7413 17.503 15.878C17.1717 16.0147 16.8797 15.9567 16.627 15.704L14.923 14H1.616ZM15.35 13L17 14.644V1.616C17 1.462 16.936 1.32067 16.808 1.192C16.68 1.06334 16.539 0.999335 16.385 1H1.615C1.46167 1 1.32067 1.064 1.192 1.192C1.06333 1.32 0.999333 1.461 1 1.615V12.385C1 12.5383 1.064 12.6793 1.192 12.808C1.32 12.9367 1.461 13.0007 1.615 13H15.35Z"
                        fill="black"
                      />
                    </svg>
                    <div>Comment</div>
                  </div>
                </td>
              </tr>
              <tr v-show="openIndex === idx" :key="`spal-collapse-` + row.id">
                <td colspan="5" class="p-0">
                  <div class="timeline p-3">
                    <div
                      v-if="!row?.comment?.length"
                      class="text-muted pl-4 pb-2"
                    >
                      No comments yet.
                    </div>
                    <div
                      v-for="c in row.comment"
                      :key="c.id"
                      class="timeline-item"
                    >
                      <div class="timeline-dot">
                        <div class="timeline-dot-inner"></div>
                      </div>
                      <div class="timeline-content">
                        <div class="font-weight-bold">{{ c.user_name }}</div>
                        <div class="text-primary small">
                          {{
                            moment(c.created_at).format(
                              'ddd, DD MMMM YYYY HH:mm'
                            )
                          }}
                        </div>
                        <div class="mt-1">{{ c.comment }}</div>
                        <div
                          v-for="att in c.comment_attachment"
                          :key="att.id"
                          class="mt-1"
                        >
                          <a
                            href="#"
                            class="text-primary small"
                            @click.prevent="
                              handleOpenFilePreview(
                                `${apiUrl}/download/${att.file_url.replace(
                                  'upload/',
                                  ''
                                )}`,
                                att.file_name
                              )
                            "
                          >
                            <i class="fa fa-paperclip mr-1"></i>
                            {{ att.file_name }}
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="chat-footer p-3 bg-white">
                      <div class="d-flex align-items-center">
                        <div class="chat-attachment d-flex align-items-center">
                          <b-dropdown
                            size="lg"
                            variant="none"
                            toggle-class="text-decoration-none"
                            dropleft
                            no-caret
                            class="m-0 p-0"
                          >
                            <template v-slot:button-content>
                              <h6 class="m-0 p-0">
                                <i class="fa fa-smile-o"></i>
                              </h6>
                            </template>
                            <b-dropdown-item href="#">
                              <VEmojiPicker @select="addEmoji" />
                            </b-dropdown-item>
                          </b-dropdown>
                          <div id="file-upload" class="d-inline-block">
                            <i
                              style="cursor: pointer"
                              @click="openFileInput"
                              class="fa fa-paperclip pr-3"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <b-form-file
                            id="file-upload"
                            class="border p-2"
                            plain
                            accept="application/*"
                            multiple
                            name="attachment"
                            v-model="formComment.attachment"
                          />
                        </div>
                        <input
                          v-model="formComment.comment"
                          type="text"
                          class="form-control mr-3"
                          placeholder="Type your message"
                        />
                        <button
                          type="button"
                          @click.prevent="onAddComment(listHistorySpal[idx].id)"
                          class="btn btn-primary d-flex align-items-center p-2"
                        >
                          <i class="fas fa-paper-plane" aria-hidden="true"></i>
                          <span class="d-none d-lg-block ml-1">Send</span>
                        </button>
                      </div>
                      <div
                        v-if="formComment.attachment.length > 0"
                        class="d-flex mt-2 align-items-center"
                      >
                        <span class="mr-2">
                          <strong>{{ formComment.attachment.length }}</strong>
                          Attachment
                        </span>
                        <a
                          href="javascript:void(0)"
                          @click="resetAttachmentComment"
                        >
                          <i
                            class="fa fa-trash text-danger"
                            aria-hidden="true"
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </b-col>
    <b-col md="12" v-else>
      <div class="alert alert-info m-4">Loading...</div>
    </b-col>
    <b-modal
      id="spal-desc-modal"
      v-model="showDescriptionModal"
      title="Description"
      hide-footer
    >
      <div v-if="selectedDescription" class="whitespace-pre-wrap">
        {{ selectedDescription }}
      </div>
      <div v-else class="text-muted">No description.</div>
    </b-modal>
  </b-row>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { busdevActions } from '@src/Utils/helper'
import { saveAs } from 'file-saver'
import { VEmojiPicker } from 'v-emoji-picker'

export default {
  name: 'SlideSpalProcess',
  props: {
    action: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: null,
    },
    closeSlideSpalProcess: {
      type: Function,
      default: () => {},
    },
    refreshDataTable: {
      type: Function,
      default: () => {},
    },
    refreshDataTableWithoutCloseModal: {
      type: Function,
      default: () => {},
    },
  },
  components: { VEmojiPicker },
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_BUSDEV_BASE_URL,

      saving: false,
      showEmojiPicker: true,
      loading: false,
      openIndex: null,
      showDescriptionModal: false,
      selectedDescription: '',

      projectData: null,
      listHistorySpal: [],

      form: {
        project_contract_id: null,
        title: '',
        notes: '',
        is_fix_spal: false,
        attachment: [],
      },
      formComment: {
        spal_process_id: null,
        user_id: JSON.parse(localStorage.getItem('profile')).id,
        user_name: JSON.parse(localStorage.getItem('profile')).userDetail.name,
        comment: '',
        attachment: [],
      },
    }
  },
  watch: {
    id: {
      deep: true,
      immediate: true,
      handler: function (value) {
        if (value) {
          this.getDetailSpalProcess(value)
        }
      },
    },
    action: {
      deep: true,
      immediate: true,
      handler: function (value) {
        if (this.id) {
          this.resetForm()
          this.getDetailSpalProcess(this.id)
        }
      },
    },
  },
  computed: {
    totalQuantityAdd() {
      return this.projectData?.project_contract_plan?.reduce(
        (total, item) => total + Number(item?.plan_quantity),
        0
      )
    },
  },
  methods: {
    ...busdevActions,
    toggleOpen(i) {
      this.openIndex = this.openIndex === i ? null : i
    },
    openDescription(row) {
      this.selectedDescription =
        row?.notes || row?.project_contract?.notes || row?.description || '-'
      this.showDescriptionModal = true
    },
    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker
    },
    addEmoji(emoji) {
      console.log(emoji, 'emoji')
      // Append the selected emoji to the message
      this.formComment.comment += emoji.data
    },
    async handleOpenFilePreview(url, filename = 'File') {
      try {
        window.open(url, '_blank')
        // const response = await fetch(`${url}`)
        // if (!response.ok) {
        //   throw new Error('Failed to fetch the PDF')
        // }
        // const blob = await response.blob()
        // saveAs(blob, `${filename}.pdf`)
      } catch (error) {
        console.error('Error downloading the PDF:', error)
      }
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)
    },
    resetAttachmentComment() {
      this.formComment.attachment = []
    },
    resetForm() {
      this.form = {
        project_contract_id: this.id,
        title: '',
        notes: '',
        is_fix_spal: false,
        attachment: [],
      }

      this.formComment = {
        spal_process_id: null,
        user_id: JSON.parse(localStorage.getItem('profile')).id,
        user_name: JSON.parse(localStorage.getItem('profile')).userDetail.name,
        comment: '',
        attachment: [],
      }
    },
    openFileInput() {
      // Create a file input element
      const fileInput = document.createElement('input')
      fileInput.type = 'file'
      fileInput.multiple = true // Allow multiple file selection
      fileInput.accept = 'application/pdf,image/*'

      // Listen for changes to the file input
      fileInput.addEventListener('change', this.handleFileUpload)

      // Trigger a click event on the file input to open the file picker
      fileInput.click()
    },
    handleFileUpload(event) {
      const files = event.target.files // Get the selected files
      const fileList = Array.from(files) // Convert FileList to Array

      this.formComment.attachment = fileList
      console.log('Uploaded files:', fileList)
      // You can now process the files, for example, send them to a server or perform other operations.
    },
    async getDetailSpalProcess(id) {
      this.loading = true
      let params = {
        params: {},
        project_contract_id: id,
      }

      const res = await this.fetchSpalProcess(params)

      if (res?.data?.status === true) {
        this.listHistorySpal = res.data.data
        this.projectData = res.data?.data?.[0]?.project_contract

        this.listHistorySpal = this.listHistorySpal?.map((val) => {
          if (val.comment.length > 0) {
            val.comment = val.comment.sort((a, b) => a.id - b.id)
          }

          return val
        })
      } else {
        this.projectData = null
        this.listHistorySpal = []
      }

      this.loading = false
    },
    async getDetailSpalProcessWithoutLoad(id) {
      let params = {
        params: {},
        project_contract_id: id,
      }

      const res = await this.fetchSpalProcess(params)

      if (res?.data?.status === true) {
        this.listHistorySpal = res.data.data

        this.listHistorySpal = this.listHistorySpal?.map((val) => {
          if (val.comment.length > 0) {
            val.comment = val.comment.sort((a, b) => a.id - b.id)
          }

          return val
        })
      } else {
        this.projectData = null
        this.listHistorySpal = []
      }
    },

    async onAddComment(id) {
      console.log(id)
      let payload = {
        ...this.formComment,
        spal_process_id: id,
      }

      let formData = new FormData()
      formData.append('spal_process_id', payload.spal_process_id)
      formData.append('user_id', payload.user_id)
      formData.append('user_name', payload.user_name)
      formData.append('comment', payload.comment)

      if (payload?.attachment?.length > 0) {
        // Append each file to FormData
        for (let i = 0; i < payload.attachment.length; i++) {
          formData.append('files', payload.attachment[i])
        }
      }

      const res = await this.createSpalProcessComment({ data: formData })

      if (res.data.status === true) {
        this.resetForm()
        this.getDetailSpalProcessWithoutLoad(this.id)
        // this.closeSlideFormPayment()
        this.$swal(`Success!`, `Comment Added.`, 'success')
      } else {
        this.$swal(`Oops!`, `Something went wrong.`, 'error')
      }
    },
    async onSaveSpalProcess() {
      this.saving = true
      let payload = {
        ...this.form,
        project_contract_id: this.id,
      }

      let formData = new FormData()
      formData.append('project_contract_id', payload.project_contract_id)
      formData.append('title', payload.title)
      formData.append('is_fix_spal', payload.is_fix_spal)
      formData.append('notes', payload.notes)

      if (payload?.attachment?.length > 0) {
        // Append each file to FormData
        for (let i = 0; i < payload.attachment.length; i++) {
          formData.append('files', payload.attachment[i])
        }
      }

      const res = await this.createSpalProcess({ data: formData })

      if (res.data.status === true) {
        this.getDetailSpalProcess(this.id)
        if (payload.is_fix_spal) {
          this.refreshDataTable()
        } else {
          this.refreshDataTableWithoutCloseModal()
        }
        this.$swal(`Success!`, `Create Spal Process Success.`, 'success')
        this.resetForm()
      } else {
        this.$swal(`Oops!`, `Something went wrong.`, 'error')
      }

      this.saving = false
    },
  },
}
</script>

<style scoped>
/* Ensure file input is hidden */
#file-upload {
  display: none;
}

/* Style for the emoji button */
.emoji-btn {
  cursor: pointer;
  margin: 10px 0;
  background-color: transparent;
  border: none;
  font-size: 24px;
}

/* Popup container for the emoji picker */
.emoji-picker-popup {
  position: absolute;
  top: 50px; /* Adjust as needed */
  left: 0;
  z-index: 1000;
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 10px;
}

/* Simple timeline styles */
.timeline {
  position: relative;
}
.timeline-item {
  display: flex;
  position: relative;
  padding-left: 24px;
  margin-bottom: 16px;
}
.timeline-item:before {
  content: '';
  position: absolute;
  left: 8px;
  top: 0;
  bottom: -17px;
  width: 2px;
  background: #e0e0e0;
}
.timeline-dot {
  position: absolute;
  left: 1px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid #3f51b5;
  display: flex;
  justify-content: center;
  align-items: center;
}
.timeline-content {
  flex: 1;
}
.timeline-dot-inner {
  background: #3f51b5;
  width: 8px;
  height: 8px;
  border-radius: 50%;;
}
</style>
